import { render, staticRenderFns } from "./ModalDraggable.vue?vue&type=template&id=0110fa81&scoped=true"
import script from "./ModalDraggable.vue?vue&type=script&lang=js"
export * from "./ModalDraggable.vue?vue&type=script&lang=js"
import style0 from "./ModalDraggable.vue?vue&type=style&index=0&id=0110fa81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110fa81",
  null
  
)

export default component.exports